import { render, staticRenderFns } from "./ApiTable.vue?vue&type=template&id=55d4c3ba&scoped=true"
import script from "./ApiTable.vue?vue&type=script&lang=js"
export * from "./ApiTable.vue?vue&type=script&lang=js"
import style0 from "./ApiTable.vue?vue&type=style&index=0&id=55d4c3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d4c3ba",
  null
  
)

export default component.exports